import React from 'react'
import { observer } from 'mobx-react-lite'
import {
  type ActionItem,
  BreadcrumbsUi,
  CalendarDropdown,
  CardsFilter,
  ContainerHeader,
  Divider,
  variantActionsProps,
} from 'shared/ui'
import { AiCallingStatus } from 'entities/AICalling/ui/AiCallingStatus/AiCallingStatus'
import { ContactsDetails } from 'widgets/ContactsDetails'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'
import { useChatbotLayoutContext } from 'pages/chatbot/context/chatbotLayoutContext'
import { useViewCallingContext } from 'pages/chatbot/pages/calling/pages/view/context'
import { getCallingActions } from 'pages/chatbot/pages/calling/actions/getCallingActions'
import { CallingActiveToggle } from 'pages/chatbot/pages/calling/ui/CallingActiveToggle'
import { StatisticsTable } from 'pages/chatbot/pages/calling/pages/view/ui/StatisticsTable/StatisticsTable'
import styles from './styles.module.scss'

export const ViewCallingUi = observer(() => {
  const { pageLayoutStore } = useChatbotLayoutContext()
  const { titleIconProps, headerMenuTooltipIconProps, headerMenuIconAction } = pageLayoutStore
  const {
    agent,
    onSuccessDelete,
    onSuccessUpdate,
    filters,
    calendarFilterStore,
    contactsDetailsStore,
  } = useViewCallingContext()

  const actions: ActionItem[] | undefined = agent
    ? getCallingActions({ item: agent, onSuccessDelete })
    : undefined

  return (
    <>
      {contactsDetailsStore && <ContactsDetails store={contactsDetailsStore} />}
      <BreadcrumbsUi path={ChatbotPath.calling} label={'Agents'} />
      <ContainerHeader
        title={agent?.name}
        titleVariant={'heading-md'}
        actionsProps={
          actions
            ? {
                ...variantActionsProps['headerMedium'],
                isStrictShowItems: true,
                showItems: 3,
                actions,
              }
            : undefined
        }
        titleIconProps={titleIconProps}
        actionIconTooltipProps={headerMenuTooltipIconProps}
        titleIconAction={headerMenuIconAction}
        className={styles.header}
      />
      <div className={styles.wrapStatus}>
        {agent && (
          <>
            <CallingActiveToggle
              item={agent}
              onSuccessUpdate={onSuccessUpdate}
              size={'small'}
              className={styles.toggle}
            />
            <AiCallingStatus status={agent.status} />
          </>
        )}
      </div>
      <div className={styles.statistics}>
        <CalendarDropdown store={calendarFilterStore} />
        <CardsFilter items={filters} type={'simple'} />
      </div>
      <Divider sx={{ marginInline: '20px', mb: 2, borderColor: 'var(--border-neutral-default)' }} />
      <StatisticsTable />
    </>
  )
})
